import Icons from "../../../../icons";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
export const ChangeAvatar = ({ children, ChangeAvatar }: { children: React.ReactNode, ChangeAvatar: any }) => {
    const [imageSrc, setImageSrc] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [imageError, setImageError] = useState('');
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async () => {
                const formData = new FormData();
                formData.append("image", file);
                formData.append("type", "userAvatar");
                const res = await fetch("__SITE_BASE__/api/v1/upload", {
                    method: "POST",
                    body: formData
                });
                const data = await res.json();
                if (res.ok) {
                    document.getElementById('preview')?.classList.remove('hidden');
                    setImageSrc(data.url);

                    fetch('__SITE_BASE__/api/me/profile/avatar', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ avatar: data.url }),
                    });

                    ChangeAvatar(data.url);
                    setIsOpen(false);
                } else {
                    setImageError(data.message)
                }
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                <DialogHeader className="items-center justify-center">
                    <DialogTitle>
                        Upload a new avatar
                    </DialogTitle>
                </DialogHeader>
                <div className="flex items-center justify-center gap-4">
                    <div className="flex flex-col items-center w-full h-full justify-center gap-1">
                        {imageError && <p className="text-red-500 text-sm">{imageError}</p>}
                        <div className="relative w-32 h-32 mt-4 items-center cursor-pointer" onClick={() => document.getElementById('image')?.click()}>
                            <div className="flex items-center justify-center w-full h-full bg-brand-darkest border-dashed border-2 border-brand-green rounded-lg overflow-hidden">
                                <img id="preview" src={imageSrc} className="absolute inset-0 object-cover w-full h-full hidden rounded" alt="Preview Image" />
                                <Icons name="picture" size="32" color="white" />
                                <input type="file" id="image" className="hidden" accept="image/png, image/jpeg, image/gif" onChange={handleImageChange} />
                            </div>
                            <div className="absolute bottom-[-10px] right-[-10px] bg-gradient-to-br from-blue-500/50 to-blue-600/50 rounded-full w-8 h-8 flex items-center justify-center">
                                <Icons name="plus" size="24" color="white" />
                            </div>
                        </div>
                        <span className="text-sm text-gray-400 mt-2">
                            (Max. 5MB)
                        </span>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );

};